import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConcise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"concise, text-shorten, squeeze"} maskId="square-filled-radius-0-stroke-1-IconConcise"><path fillRule="evenodd" clipRule="evenodd" d="M8.5 2.79291L12 6.29291L15.5 2.79291L16.2071 3.50001L12 7.70712L7.79289 3.50001L8.5 2.79291ZM3 10H21V11H3V10ZM3 13H21V14H3V13ZM12 16.2929L16.2071 20.5L15.5 21.2071L12 17.7071L8.5 21.2071L7.79289 20.5L12 16.2929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconConcise;
